import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Modal,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { generateRandomID } from "@/utils/generateRandomID";
import { encrypt, decrypt } from "@/utils/crypto";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { setAuthData, setAuthenticated } from "../../../redux/auth/authSlice";
import {
  checkPhoneNumberInUse,
  registerUser,
  handleSocialAuth,
  isAppleRegisteredUser,
  getRequestId,
  signIn,
  googleSignin,
  validateEmail,
  updateUserDetails,
  sendVerificationCode,
  alertsSummary,
} from "@/api/LoginSignup";
import { toast } from "react-toastify";
import { useGoogleLogin } from "@react-oauth/google";
import ForgotPassword from "./ForgotPassword";
import OTPVerification from "./OtpVerification/OTPVerification";
import "./LoginSignUp.css";
import Captcha from "@/components/captcha";
import { getLoginSignupCMS, isValidPassword } from "@/api/LoginSignup";
import {
  setIsOtpVerificationModalRequired,
  setIsUserSubscribed,
  setLoginModal,
  setShowContinueBtn,
  setShowTabsInModal,
  setSubscribeEmailAlreadyExists,
  setLoginTab,
} from "@/redux/login/loginSlice";
import { setIsAddedToSaved } from "@/redux/savedpreference/savedPreferenceSlice";
import FairHousingIcon from "../../../../public/assets/images/home/FairHousingIcon.svg";
import {
  checkLoginStatus,
  checkValidEmailAddress,
  getUserProfile,
  getUserProfileVerificationDetails,
} from "@/api/myProfile";
import ChangePassword from "../../user/AccountSettings/ChangePassword";
import { validateForm } from "@/utils/formValidator";

import {
  setAlertsRegister,
  userData,
  setProfileInfo,
  setFirebaseConfig,
  setPasswordExpired,
  logOut,
} from "@/redux/user/userSlice";

import { deleteCookie, getCookie, setCookie } from "@/utils/cookies";
import LoadingText from "@/components/loader/LoadingText";
import LoadedText from "@/components/loader/LoadedText";
import { showOtpModal } from "@/redux/otpModal/otpModalSlice";
import { isPhoneNoVerified } from "@/api/bid";
import { jwtDecode } from "jwt-decode";
import UserProfileForm from "@/components/form/UserProfileForm";
import { getWebCMS } from "@/api/PDP";
import { store } from "@/store/store";
import useAuth from '@/components/common/header/useAuth';

import { authenticateFirebase } from "../FirebaseApp";

import {
  getEventCategory,
  trackApiCall,
  trackButtonClick,
  trackPageMount,
  clearAnalyticsCache,
} from "@/utils/analytics";
import Cookies from "js-cookie";
import { FaAngleRight } from "react-icons/fa";
import { globalCmsData } from "@/redux/cms/cmsSelectors";
import { saveRecentSearch } from "@/api/savedSearch";
import { getUserRecentSearch } from "@/api/home";

const metadata = {
  title: "Hubzu |",
  description: "",
};

// let hasTracked = false;

const LoginSignup = ({
  isFromAlerts,
  isOtpVerificationModal = false,
  popUpMsg,
  passwordExpired = false,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const globalData = useSelector(globalCmsData);
  const abc = "553916229230-n59095qca4t7e9l0h644ajr2gn7aq0vn.apps.googleusercontent.com";
  const {  userSignOut } = useAuth();

  const show = useSelector((state) => state.login);
  const [isEmailValid, setIsEmailValid] = useState(false);
  const [pageLoading, setPageLoading] = useState(false);
  const [isUserDetailsUpdating, setIsUserDetailsUpdating] = useState(false);
  const [isLogin, setIsLogin] = useState(true);
  const [email, setEmail] = useState("");
  const [addedPhoneNumber, setAddedPhoneNumber] = useState();
  const [phoneNumberError, setPhoneNumberError] = useState();
  const [isPhoneNumberNotAvailable, setIsPhoneNumberNotAvailable] =
    useState("");

  const [password, setPassword] = useState("");
  const [userPhoneNumber, setUserPhoneNumber] = useState(null);
  const [isConfirmProfileActive, setConfirmProfileActive] = useState(false);
  const [isPhoneNumberVerification, setIsPhoneNumberVerification] =
    useState(false);
  const [loginError, setLoginError] = useState(null);
  const [registrationError, setRegistrationError] = useState(null);
  const [showHelp, setShowHelp] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showAppleDetailsScreen, setShowAppleDetailsScreen] = useState(false);
  const [isAppleUserNotRegistered, setIsAppleUserNotRegistered] =
    useState(false);
  const [appleUserInfo, setAppleUserInfo] = useState();
  const [appleEmailError, setAppleEmailError] = useState();
  const firebaseConfig = useSelector((state) => state.user.firebaseConfig);
  const state = store.getState();
  const userID = state?.user?.user?.realbidUserId;
  const [passwordVisibility, setPasswordVisibility] = useState({
    password: false,
    confirmPassword: false,
  });
  const [userDetails, setUserDetails] = useState({
    firstName: "",
    lastName: "",
    phoneNumber: "",
    email: "",
  });

  const [appleRegisterationDetails, setAppleRegisterationDetails] = useState({
    firstName: "",
    lastName: "",
    email: "",
  });

  // const [appleFieldErrors, setAppleFieldErrors] = useState({
  //   firstName: "",
  //   lastName: "",
  //   email: "",
  // });

  const [isLoading, setIsLoading] = useState(false);
  const [phoneError, setPhoneError] = useState("");
  const [fieldErrors, setFieldErrors] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    password: "",
    confirmPassword: "",
  });
  const [loginFieldErrors, setLoginFieldErrors] = useState({
    username: "",
    password: "",
  });
  const [updateDetails, setUpdateDetails] = useState(false);
  const [registrationFormData, setRegistrationFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    password: "",
    confirmPassword: "",
  });
  const [formErrors, setFormErrors] = useState({
    email: "",
    password: "",
    firstName: "",
    lastName: "",
  });
  const [warningMessage, setWarningMessage] = useState("");
  const [showCutomerCare, setShowCustomerCare] = useState(true);
  const [isSocialSignin, setIsSocialSignin] = useState(false);
  const [isFreshSocialSignin, setIsFreshSocialSignin] = useState(false);
  const [showCaptcha, setShowCaptcha] = useState(true);
  const [captchaError, setCaptchaError] = useState(true);
  const [captchaErrorMessage, setCaptchaErrorMessage] = useState(true);
  const [ShowIdologyModal, setShowIdologyModal] = useState(true);
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [formData, setFormData] = useState({});
  const [errors, setLoginErrors] = useState({});
  const [appleFieldErrors, setAppleFieldErrors] = useState({});

  const [hasChanges, setHasChanges] = useState(false);
  const [CmsData, setCmsData] = useState([]);
  const [touched, setTouched] = useState({});
  const userSubscribed = getCookie("subscribedUser");
  const [changePhoneErrorMsg, setChangePhoneErrorMsg] = useState();
  const [isFromLoginSignupPage, setIsFromLoginSignupPage] = useState(true);
  const [otpErrorMessage, setOtpErrorMessage] = useState("");
  const [fieldApiValidationRunning, setFieldApiValdiationRunning] =
    useState(false);

  const [shouldShowRegister, setShoulShowRegister] = useState(false);
  const [registerLoading,setRegisterLoading] = useState(false)
  const [showPasswordExpired, setShowPasswordExpired] = useState(false);

  const closeModal = () => {
    setShowIdologyModal(false);
  };

  const handleProfileActiveStatus = (status) => {
    setConfirmProfileActive(status);
  };

  useEffect(() => {
    getLoginSignupCMS("pages/loginSignup").then((response) => {
      setCmsData(response?.results?.[0]);
       setShowCaptcha(response?.results?.[0]?.captchaEnabled || false);
      setCaptchaError(response?.results?.[0]?.captchaEnabled || false);
      setIsLoading(response?.results?.[0]?.captchaEnabled || false)
    });
  }, []);

  useEffect(() => {
    if (userSubscribed) {
      setRegistrationFormData({
        ...registrationFormData,
        email: getCookie("userEmail"),
      });
    }
  }, [userSubscribed]);

  const handleIsValidEmail = async (emailId) => {
    if (emailId) {
      setFieldApiValdiationRunning(true);
      try {
        const isValid = await checkValidEmailAddress(emailId);

        if (isValid?.status === "VALIDATION_DUPLICATE_EMAIL") {
          setFieldErrors((prevErrors) => ({
            ...prevErrors,
            email: "Email address already in use",
          }));

          if (showAppleDetailsScreen) {
            setAppleFieldErrors((prevErrors) => ({
              ...prevErrors,
              email: "Email address already in use",
            }));
          }
          setLoginError(null);
        } else {
          setEmailError("");
          if (showAppleDetailsScreen) {
            setAppleFieldErrors((prevErrors) => ({
              ...prevErrors,
              email: "",
            }));
          }
        }
      } catch (error) {
        if (showAppleDetailsScreen) {
          setAppleFieldErrors((prevErrors) => ({
            ...prevErrors,
            email: "Error checking email availability",
          }));
        }
        setEmailError("Error checking email availability");
        console.error("Error checking email:", error);
      } finally {
        setFieldApiValdiationRunning(false);
      }
    }
  };

  useEffect(() => {
    const cookies = document.cookie.split(";");
    const userEmailCookie = cookies.find((cookie) =>
      cookie.trim().startsWith("userEmail=")
    );
    setEmail(getCookie("userEmail"));


    // setShoulShowRegister(getCookie("userEmail") === null || !getCookie("userEmail") ? true : false);
    // setShoulShowRegister(!getCookie("userEmail") || userSubscribed);
      if (!getCookie("userEmail") || userSubscribed) {
    setShoulShowRegister(true);
    setIsLogin(false);
  }

  }, [show?.loginModal]);

  // Helper function to handle API errors
  const handleApiErrors = (errors) => {
    if (!errors) return;

    const apiErrors = {};
    errors.forEach((error) => {
      const fieldMapping = {
        firstName: "firstName",
        lastName: "lastName",
        emailId: "email",
        phoneNumber: "phone",
      };

      if (fieldMapping[error.field]) {
        apiErrors[fieldMapping[error.field]] = error.message;
      } else {
        setRegistrationError(error.message);
      }
    });
    //setFieldErrors(apiErrors);
  };

  // Helper function to handle registration errors
  const handleRegistrationError = (error) => {
    if (error.response?.data?.field) {
      setFieldErrors((prev) => ({
        ...prev,
        [error.response.data.field]: error.response.data.message,
      }));
    } else {
      toast.error(error.message || error.errorMessage || "Registration failed");
      // dont show login error alert for this error
      if (error.errorMessage === "VALIDATION_DUPLICATE_EMAIL") {
        setLoginError(null);
      } else {
        setRegistrationError(
          error.message || error.errorMessage || "Registration failed"
        );
      }
    }
  };

  const handleShowHelp = () => {
    setShowHelp(true);
    setIsLogin(false);
    setShowCustomerCare(true);

    trackButtonClick({
      eventName: "forgot_password_link_click",
      eventSource: "Forgot password link click",
      eventCategory: "New-Registration",
    });
  };

  const handleToggleRegister = () => {
      setShoulShowRegister(false);
  }
  const handleToggle = () => {

    setIsLogin(!isLogin);
    setShoulShowRegister(isLogin);

    trackButtonClick({
      eventName: "auth_popup_cta_click",
      eventSource: "Register/Signin toggle click",
      eventCategory: "/register-sign-in",
      eventParams: { mode: isLogin ? "register" : "signin" },
    });
  };

  function setLoginCookie(email) {
    try {
      const expirationDate = new Date();
      expirationDate.setDate(expirationDate.getDate() + 30);
      // Properly formatted cookie string without line breaks
      document.cookie = `userEmail=${email}; expires=${expirationDate.toUTCString()}; path=/; SameSite=Strict`;
      setCookie("loggedInEmail", email, 30);
    } catch (error) {
      console.error("Error setting cookie:", error);
    } finally {
      setIsLoading(false); // Hide loader regardless of success/failure
    }
  }

  const handleLoginFieldChange = (e) => {
    const { name, value } = e.target;

    // Update form data
    if (name === "email") {
      setEmail(value);
    } else if (name === "password") {
      setPassword(value);
    }

    // Clear validation errors when field is emptied
    if (value === "") {
      setLoginFieldErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "",
      }));
      return; // Skip validation for empty fields
    }

    if (name === "password") {
      // Validate non-empty fields
      const validationErrors = validateForm(
        { [name]: value },
        [name],
        true,
        false
      );

      setLoginFieldErrors((prevErrors) => ({
        ...prevErrors,
        [name]: validationErrors[name] || "",
      }));
    } else if (name === "email") {
      setLoginFieldErrors((prevErrors) => ({
        ...prevErrors,
        email: "",
      }));
    }
  };

  const handleFormLogin = async (e) => {
    e.preventDefault();
    setLoginError(null);
    setPageLoading(true);
    setIsLoading(true);

    trackButtonClick({
      eventName: "user_sign_in_click",
      eventSource: "User signin button click",
      eventCategory: "Sign-In",
    });

    try {
      // Validate required fields
      const validationErrors = validateForm(
        { email, password },
        ["email", "password"],
        true,
        false
      );

      // Check if there are any validation errors
      const hasErrors = Object.values(validationErrors).some(
        (error) => error !== ""
      );
      if (hasErrors) {
        setLoginFieldErrors(validationErrors);
        return;
      }

      // if (captchaError) {
      //   setCaptchaErrorMessage("Error!!")
      //   return;
      // }

      // Validate email first
      await validateEmailOnBlur();

      const payload = {
        requestId: generateRandomID(),
      };
      getRequestId(payload);
      const loginFormdata = new FormData();
      loginFormdata.append("username", email);
      loginFormdata.append("password", await encrypt(password));
      loginFormdata.append("requestId", payload.requestId);
      loginFormdata.append("cryptoAlgVersion", "V3");
      loginFormdata.append("encAlgVersion", "V4");

      const redisPayload = new FormData();
      redisPayload.append("emailAddr", await encrypt(email));

      const response =
        (!showCaptcha || !captchaError) && (await signIn(loginFormdata));

      if (response && response?.status == "SUCCESS") {
        // Check if password is expired
        if (response?.data?.passwordExpired === 'Y') {
          setShowPasswordExpired(true);
          dispatch(setPasswordExpired(true));
          return;
        }
        dispatch(setPasswordExpired(false));
        setPasswordExpired(false);
        setLoginCookie(email);
        localStorage.setItem("userFirstName", response.userFirstName);
        localStorage.setItem("userLastName", response.userLastName);

        await postSuccesfulSignIn();

        const profData = await checkLoginStatus();

        dispatch(
          userData({
            userFirstName: profData.userFirstName,
            userType: profData.userType,
            isUserLoggedIn: true,
            user: profData,
          })
        );

        trackApiCall({
          eventName: "user_sign_in_success",
          eventSource: "User signin button click",
          eventCategory: "Sign-In",
          user_uid: profData?.realbidUserId || "",
        });

        //This API is no longer required (optimizely)
        // await getExperiments("onLogin");
        // const userProfileData = await getUserProfileVerificationDetails();
        setUserDetails({
          email: profData?.userEmailId,
          firstName: profData?.userFirstName,
          lastName: profData?.userLastName,
          phoneNumber: profData?.primaryPhone,
        });

        const phoneNumber = userDetails.phoneNumber;
        setUserPhoneNumber(profData?.primaryPhone);



        await isPhoneNoVerified(profData?.primaryPhone);
        // const isPhoneVerified = isPhoneVerifiedResponse?.data?.data;
        const isPhoneVerified =
          response?.data?.user?.loggedInUserDetail?.phoneNumberVerified;

        dispatch(setIsOtpVerificationModalRequired(!isPhoneVerified));
        setIsFromLoginSignupPage(true);

        if (isOtpVerificationModal && !isPhoneVerified) {
          dispatch(
            showOtpModal({
              phoneNumber: phoneNumber,
              redirectScreen: "LOGINSIGNUP",
            })
          );
        }
        dispatch(setSubscribeEmailAlreadyExists(false));

        if (show?.location === "Alerts" || show?.location === "Popup") {
          dispatch(
            userData({
              userFirstName: profData.userFirstName,
              userType: "BUYR",
              isUserLoggedIn: true,
              user: {
                ...profData,
                firstName: profData.userFirstName,
                lastName: profData.userLastName,
                email: profData.userEmailId,
                phone: profData.primaryPhone,
              },
            })
          );
          dispatch(setAlertsRegister(true));
        }
        if (show?.loginModal) {
          dispatch(setLoginModal(false));
          dispatch(setIsAddedToSaved(true));
          if (!isPhoneVerified) setIsPhoneNumberVerification(true);
        } else {
          if (isPhoneVerified) {
            navigate("/");
          } else {
            setIsPhoneNumberVerification(true);
          }
        }
        // const decryptedData = await decrypt(response.data);
        const decryptedData = await response.data;

        dispatch(setAuthData(decryptedData));
      } else {
        trackApiCall({
          eventName: "user_sign_in_failure_error",
          eventSource: "User signin api call",
          eventCategory: "Sign-In",
        });
        setCaptchaError(false)
        // Handle the specific error response format
        if (response?.status === "error") {
          switch (response.errorMessage) {
            case "NO_RECORDS_FROM_DB":
              setLoginError(
                "Authentication failed. Invalid email address, password combination."
              );
              break;
            case "INVALID_LOGIN_DETAILS":
              setLoginError(
                "Authentication failed. Invalid email address, password combination."
              );
              break;
            case "ACCOUNT_LOCKED_ERROR_MSG":
              setLoginError(
                "Sorry, your account has been locked. Please contact Customer Care at (855) 882-1314."
              );
              break;
            case "ACCOUNT_INACTIVE":
              setLoginError(
                "Your account is inactive. Please verify your email."
              );
              break;
            case "INVALID_REQUEST_PARAMETER":
              setLoginError("Please enter a valid credentials");
              break;
            case "ACCOUNT_SUSPENDED_ERROR_MSG":
              setLoginError(
                "Your account has been suspended. Please contact Customer Care at (855) 882-1314."
              );
              break;
            case "ACCOUNT_DELETED_ERROR_MSG":
              setLoginError(
                "Account doesn't exist. Please reach out to Customer Care at (855) 882-1314."
              );
              break;
            case "LOGIN_LEADUSER_ERROR_MESSAGE":
              setLoginError(
                "Email address not registered. Please register to continue."
              );
              break;
            case "VALIDATION_DUPLICATE_EMAIL":
              setLoginError(null); // for email validation
              break;
            default:
              setLoginError(
                response.errorMessage ||
                "An error occurred during login. Please try again."
              );
          }
          return; // Exit the function early
        }
      }
    } catch (error) {
      setLoginError("");
      console.error("Login error:", error);
      trackApiCall({
        eventName: "user_sign_in_failure_error",
        eventSource: "User signin api call",
        eventCategory: "Sign-In",
      });
      toast.error(error.message || "Sign in failed");
    } finally {
      setIsLoading(false);
      setPageLoading(false);
    }
    setLoginCookie(email);
  };

  const handleOtpVerification = () => {
    setIsPhoneNumberVerification(true);
    setIsSocialSignin(false);
  };

  const handlePasswordVisibility = (field) => {
    setPasswordVisibility((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }));
  };

  const printWarning = (msg) => {
    setWarningMessage(msg);
  };
  useEffect(() => {
    if (show?.subscribeEmailAlreadyExists) {
      printWarning("You are already part of Hubzu, please login to continue.");
      setEmail(getCookie("userEmail"));
    }
  }, [show?.subscribeEmailAlreadyExists]);

  const googleLogin = abc ? useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      try {
        setLoginError("");

        // Get user info using access token
        const userInfoResponse = await fetch(
          "https://www.googleapis.com/oauth2/v3/userinfo",
          {
            headers: {
              Authorization: `Bearer ${tokenResponse.access_token}`,
              Accept: "application/json",
            },
          }
        );

        const userInfo = await userInfoResponse.json();

        // Create payload
        // const googleUser = {
        //   encAlgVersion: "V4",
        //   service: 'google',
        //   token: tokenResponse.access_token
        // };
        const googleUser = {
          encAlgVersion: "V3",
          emailId: await encrypt(userInfo.email),
          firstName: userInfo.given_name,
          lastName: userInfo.family_name,
          emailVerified: userInfo.email_verified.toString(),
        };

        trackButtonClick({
          eventName: "continue_with_google",
          eventSource: "Signin with google click",
          eventCategory: "/register-sign-in",
        });

        const response = await googleSignin(googleUser);

        if (response?.status === "SUCCESS") {
          store.dispatch(setAuthenticated(true));

          const isUserNewlyRegistered = response?.data?.isRegistered || false;

          setIsSocialSignin(true);
          setIsFreshSocialSignin(isUserNewlyRegistered);

          const { status, data } = await getUserProfile();
          dispatch(setProfileInfo(data));
          setIsFromLoginSignupPage(true);

          if (isUserNewlyRegistered) {
            const registeredUserId =
              data?.userDetails?.realbidUserId ||
              data?.realbidUserId ||
              data?.userDetails?.userId ||
              "";
            // Sync the analytics user id to the `gaUserId` cookie so
            // getUserContext() can attach user_uid to all subsequent events.
            if (registeredUserId) {
              setCookie("gaUserId", registeredUserId, 30);
            }
            trackApiCall({
              eventName: "register_completed",
              eventCategory: getEventCategory(),
              eventSource: "Registration Form Submit",
              user_uid: registeredUserId,
            });
          }

          trackApiCall({
            eventName: "user_sign_in_success",
            eventSource: "Google signin success",
            eventCategory: "Sign-In",
            user_uid:
              data?.userDetails?.realbidUserId ||
              data?.realbidUserId ||
              data?.userDetails?.userId ||
              "",
          });

          await postSuccesfulSignIn();

          const profData = await checkLoginStatus();

          dispatch(
            userData({
              userFirstName: profData.userFirstName,
              userType: profData.userType,
              isUserLoggedIn: true,
              user: profData,
            })
          );

          if (
            !data?.userDetails?.phoneNumber ||
            data?.userDetails?.phoneNumber?.length === 0
          ) {
            setIsPhoneNumberNotAvailable(true);
          }

          const isPhoneVerified = data?.userDetails?.phoneNumberVerified;

          dispatch(setIsOtpVerificationModalRequired(!isPhoneVerified));

          if (isOtpVerificationModal && !isPhoneVerified) {
            const phoneNumber = data?.userDetails?.phoneNumber;
            dispatch(
              showOtpModal({
                phoneNumber: phoneNumber,
                redirectScreen: "LOGINSIGNUP",
              })
            );
          }

          await postSuccesfulSignIn();

          // await getExperiments("IntroHubzu");
          const redisPayload = new FormData();
          redisPayload.append(
            "emailAddr",
            response?.data?.user?.loggedInUserDetail?.userEmailId
          );


          if (show?.location === "Alerts" || show?.location === "Popup") {
            dispatch(
              userData({
                userFirstName: profData?.userFirstName?.trim(),
                userType: "BUYR",
                isUserLoggedIn: true,
                user: {
                  ...profData,
                  firstName: profData.userFirstName.trim(),
                  lastName: profData.userLastName.trim(),
                  email: profData?.userEmailId.trim(),
                  phone: profData?.primaryPhone,
                },
              })
            );

            console.log("userData -> ", userData);
            dispatch(setAlertsRegister(true));
            setCookie("subscribedUser", false);
            dispatch(setIsUserSubscribed(false));
            deleteCookie("subscribeEmail");
          }
          if (show?.loginModal) {
            dispatch(setLoginModal(false));
            dispatch(setIsAddedToSaved(true));
          }

          setLoginCookie(registrationFormData?.email?.trim());

          localStorage.setItem(
            "user",
            JSON.stringify({
              firstName: data?.userDetails?.firstName?.trim(),
              lastName: data?.userDetails?.lastName?.trim(),
              email: data?.userDetails?.email?.trim(),
              phone: data?.userDetails?.phone,
            })
          );

          setUserDetails({
            firstName: data?.userDetails?.firstName?.trim(),
            lastName: data?.userDetails?.lastName?.trim(),
            email: data?.userDetails?.emailId?.trim(),
            phoneNumber: data?.userDetails?.phoneNumber,
          });

          isUserNewlyRegistered && toast.success("Registration successful!");
          setIsPhoneNumberVerification(!isPhoneVerified);
        } else {
          trackApiCall({
            eventName: "user_sign_in_failure_error",
            eventSource: "Google signin failure",
            eventCategory: "Sign-In - authentication failed",
          });
          throw new Error(
            response.message || response.errorMessage || "Authentication failed"
          );
        }
      } catch (error) {
        console.error("Google login error:", error);

        // Extract error code from "Error: ACCOUNT_DELETED_ERROR_MSG" format
        let errorMsg = error.message || error || "Failed to login with Google";

        if (errorMsg.includes("ACCOUNT_DELETED_ERROR_MSG")) {
          errorMsg =
            "Account doesn't exist. Please reach out to Customer Care at (855) 882-1314.";
        }

        trackApiCall({
          eventName: "user_sign_in_failure_error",
          eventSource: "Google signin failure",
          eventCategory: `Sign-In - ${errorMsg}`,
        });
        setLoginError(errorMsg || "Failed to login with Google");
        toast.error("Google login failed");
      } finally {
      }
    },
  }) : null;

  useEffect(() => {
    // Load Apple Sign In Script
    const loadAppleScript = () => {
      const script = document.createElement("script");
      script.src =
        "https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js";
      script.async = true;
      script.id = "apple-sign-in-script";
      document.body.appendChild(script);

      return () => {
        const scriptTag = document.getElementById("apple-sign-in-script");
        if (scriptTag) document.body.removeChild(scriptTag);
      };
    };

    // Check if script is already loaded
    if (!document.getElementById("apple-sign-in-script")) {
      loadAppleScript();
    }
  }, []);

  // Helper function to generate nonce
  const generateNonce = () => {
    const charset =
      "0123456789ABCDEFGHIJKLMNOPQRSTUVXYZabcdefghijklmnopqrstuvwxyz";
    let random = "";
    for (let i = 0; i < 32; i++) {
      random += charset.charAt(Math.floor(Math.random() * charset.length));
    }
    return random;
  };

  const handleAppleLogin = async () => {
    try {
      setLoginError("");
      let uri = "";
      const host = window.location.host;
      if (host === "preview.hubzu.com") {
        uri = window.location.origin + "/";
      } else if (host === "hubzu.com" || host === "www.hubzu.com") {
        uri = window.location.origin + "/";
      } else if (host === "trunkhubzu-integ.internal.hubzu.com") {
        uri = window.location.origin;
      } else if(host === "mirror.hubzu.com"  || host === "www.mirror.hubzu.com"){
         uri = window.location.origin + "/";
      }
      else {
        uri = "https://buy-bid-participation-feature-web-ui.internal.hubzu.com";
      }

      trackButtonClick({
        eventName: "continue_with_apple",
        eventSource: "Signin with Apple click",
        eventCategory: "/register-sign-in",
      });

      if (!window.AppleID) {
        throw new Error("Apple Sign In is not initialized");
      }
      await window.AppleID.auth.init({
        clientId: "com.hubzu.internal",
        scope: "name email",
        redirectURI:uri,
        // "https://buy-bid-participation-feature-web-ui.internal.hubzu.com",  // need to be fixed with proper env variable
        state: "origin:web",
        usePopup: true,
        nonce: generateNonce(),
        response_mode: "form_post",
        response_type: "code id_token",
      });

      const appleResponse = await window.AppleID.auth.signIn();
      console.log("Apple Sign In Response:", appleResponse);

      const idToken = appleResponse?.authorization?.id_token;

      if (!idToken) {
        trackApiCall({
          eventName: "user_sign_in_failure",
          eventSource: "Apple signin failure",
          eventCategory: "Sign-In - invalid token id",
        });
        throw new Error("No authentication token received from Apple");
      }

      // ✅ Decode id_token to extract Apple user info
      // const decodedIdToken = jwtDecode(idToken);
      // const appleId = decodedIdToken.sub;
      // const appleEmail = decodedIdToken.email;

      const decodedIdToken = jwtDecode(idToken);
      const appleId = decodedIdToken.sub;
      const appleToken = idToken;
      const appleEmail = decodedIdToken.email;
      // Build user payload

      const appleUser = {
        token: idToken,
        jwtToken: idToken,
        code: appleResponse.authorization.code,
        firstName: appleResponse?.user?.name
          ? appleResponse?.user?.name.firstName
          : "",
        lastName: appleResponse?.user?.name
          ? appleResponse?.user?.name.lastName
          : "",
        emailId: appleResponse?.user?.email ? appleResponse?.user?.email : "",
        encAlgVersion: "V4",
        newURI: "Y",
      };

      const data1 = {
        jwtToken: idToken,
        // 'code': response.code,
        // 'email': email,
        // 'fname': fname,
        // 'lname': lname,
        encAlgVersion: "V4",
      };

      let data = await isAppleRegisteredUser(data1);
      setAppleUserInfo(appleResponse);
      setIsAppleUserNotRegistered(!data?.data?.isRegistered);
      if (data?.data?.isRegistered === true) {
        setShowAppleDetailsScreen(false);

        const response = await handleSocialAuth(appleUser, "appleWeb");

        if (response?.status === "SUCCESS") {
          const isUserNewlyRegistered = response?.data?.isRegistered || false;

          setIsSocialSignin(true);
          setIsFreshSocialSignin(isUserNewlyRegistered);

          const { status, data } = await getUserProfile();
          dispatch(setProfileInfo(data));
          setIsFromLoginSignupPage(true);

          store.dispatch(setAuthenticated(true));

          if (isUserNewlyRegistered) {
            const registeredUserId =
              data?.userDetails?.realbidUserId ||
              data?.realbidUserId ||
              data?.userDetails?.userId ||
              "";
            // Sync the analytics user id to the `gaUserId` cookie so
            // getUserContext() can attach user_uid to all subsequent events.
            if (registeredUserId) {
              setCookie("gaUserId", registeredUserId, 30);
            }
            trackApiCall({
              eventName: "register_completed",
              eventCategory: getEventCategory(),
              eventSource: "Registration Form Submit",
              user_uid: registeredUserId,
            });
          }

          trackApiCall({
            eventName: "user_sign_in_success",
            eventSource: "Apple signin success",
            eventCategory: "Sign-In",
            user_uid:
              data?.userDetails?.realbidUserId ||
              data?.realbidUserId ||
              data?.userDetails?.userId ||
              "",
          });

          await postSuccesfulSignIn();

          const profData = await checkLoginStatus();

          dispatch(
            userData({
              userFirstName: profData.userFirstName,
              userType: profData.userType,
              isUserLoggedIn: true,
              user: profData,
            })
          );

          const isPhoneVerified = data?.userDetails?.phoneNumberVerified;

          if (
            !data?.userDetails?.phoneNumber ||
            data?.userDetails?.phoneNumber?.length === 0
          ) {
            setIsPhoneNumberNotAvailable(true);
          }
          dispatch(setIsOtpVerificationModalRequired(!isPhoneVerified));

          if (isOtpVerificationModal && !isPhoneVerified) {
            const phoneNumber = data?.userDetails?.phoneNumber;
            dispatch(
              showOtpModal({
                phoneNumber: phoneNumber,
                redirectScreen: "LOGINSIGNUP",
              })
            );
          }

          await postSuccesfulSignIn();

          // await getExperiments("IntroHubzu");
          const redisPayload = new FormData();
          redisPayload.append(
            "emailAddr",
            response?.data?.user?.loggedInUserDetail?.userEmailId
          );


          if (show?.location === "Alerts" || show?.location === "Popup") {
            dispatch(
              userData({
                userFirstName: profData?.userFirstName?.trim(),
                userType: "BUYR",
                isUserLoggedIn: true,
                user: {
                  ...profData,
                  firstName: profData.userFirstName.trim(),
                  lastName: profData.userLastName.trim(),
                  email: profData?.userEmailId.trim(),
                  phone: profData?.primaryPhone,
                },
              })
            );
            dispatch(setAlertsRegister(true));
            setCookie("subscribedUser", false);
            dispatch(setIsUserSubscribed(false));
            deleteCookie("subscribeEmail");
          }
          if (show?.loginModal) {
            dispatch(setLoginModal(false));
            dispatch(setIsAddedToSaved(true));
          }

          setLoginCookie(registrationFormData?.email?.trim());

          localStorage.setItem(
            "user",
            JSON.stringify({
              firstName: data?.userDetails?.firstName?.trim(),
              lastName: data?.userDetails?.lastName?.trim(),
              email: data?.userDetails?.email?.trim(),
              phone: data?.userDetails?.phone,
            })
          );

          setUserDetails({
            firstName: data?.userDetails?.firstName?.trim(),
            lastName: data?.userDetails?.lastName?.trim(),
            email: data?.userDetails?.emailId?.trim(),
            phoneNumber: data?.userDetails?.phoneNumber,
          });

          isUserNewlyRegistered && toast.success("Registration successful!");
          setIsPhoneNumberVerification(!isPhoneVerified);
        } else {
          trackApiCall({
            eventName: "user_sign_in_failure_error",
            eventSource: "Apple signin failure",
            eventCategory: "Sign-In",
          });
          throw new Error(
            response.message || response.errorMessage || "Authentication failed"
          );
        }
      } else {
        setShowAppleDetailsScreen(true);
      }
    } catch (error) {
      console.error("Apple login error:", error);

      // Extract error code from "Error: ACCOUNT_DELETED_ERROR_MSG" format
      let errorMsg = error.message || error || "Failed to login with Apple";

      if (errorMsg.includes("ACCOUNT_DELETED_ERROR_MSG")) {
        errorMsg =
          "Account doesn't exist. Please reach out to Customer Care at (855) 882-1314.";
      }

      trackApiCall({
        eventName: "user_sign_in_failure_error",
        eventSource: "Apple signin failure",
        eventCategory: `Sign-In - ${error?.message}`,
      });

      let errorMessage = "Failed to login with Apple";

      if (error.error === "popup_closed_by_user") {
        errorMessage = "Apple sign in was cancelled";
      } else if (error.error === "invalid_client") {
        errorMessage = "Invalid client configuration";
      } else if (error.error === "invalid_scope") {
        errorMessage = "Invalid scope requested";
      } else if (error.error === "unauthorized") {
        errorMessage = "Unauthorized access";
      } else if (errorMsg?.includes("not initialized")) {
        errorMessage = "Apple Sign In is not properly configured";
      } else if (
        errorMsg?.includes("No authentication token received from Apple")
      ) {
        errorMessage = "No authentication token received from Apple";
      } else if (errorMsg?.includes("Authentication failed")) {
        errorMessage = "Authentication failed";
      } else {
        errorMessage =
          errorMsg || "Unknown error occurred during Apple Sign In";
      }
      setLoginError(errorMessage);
      toast.error(errorMessage);
    } finally {
      // Optionally toggle loading
    }
  };

  const validateEmailOnBlur = async () => {
    if (formErrors.email) return;
    // setFieldApiValdiationRunning(true);
    setIsEmailValid(false);
    setLoginError(null);

    // Validate the email format
    const validationErrors = validateForm({ email }, ["email"], true, false);

    // Update the error state with validation results
    setLoginFieldErrors((prevErrors) => ({
      ...prevErrors,
      email: validationErrors.email || "",
    }));

    try {
      const encodedEmail = encodeURIComponent(email);
      if (!encodedEmail) return;
      const queryString = `email=${encodedEmail}`;

      // Validate the email
      const response = await validateEmail(queryString);

      if (response.status !== "SUCCESS" && CmsData?.captchaEnabled) {
        // setShowCaptcha(false);
        // if (response.errorMessage === "NO_RECORDS_FROM_DB") {
        //   setLoginError(
        //     "Authentication failed. Invalid email address, password combination."
        //   );
        // }
        // return;
      } else if (response.status === "SUCCESS") {
        setIsEmailValid(true); // email is valid
      }
      // Show captcha if the user is external and captcha is enabled
      const isExternalUser =
        response.data?.internalUser === "N" ||
        response.data?.internalUser === null;
      if (isExternalUser && CmsData?.captchaEnabled) {
        setShowCaptcha(true);
          setCaptchaError(true);
          setIsLoading(true);
        // captchaError && setIsLoading(true);
      } else {
        setShowCaptcha(false);
        setCaptchaError(false);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Error validating email:", error);
    } finally {
      // setFieldApiValdiationRunning(false);
    }
  };
useEffect(() => {
  const validatePrefilledEmail = async () => {
    if (email && email.length > 0) {
      await validateEmailOnBlur();
    }
  };

  validatePrefilledEmail();
}, [CmsData]);

  // Clear password field when password is changed
  useEffect(() => {
    setPassword('');
  }, [show?.clearPasswordFlag]);
  const handleRegisterSubmit = (e) => {
    e.preventDefault();

    // Validate all fields before submission
    const validationErrors = validateForm({ email, password });

    if (Object.keys(validationErrors).length === 0) {
      // Proceed with form submission
      console.log("Form is valid, proceeding with submission");
      // Add your submission logic here
    } else {
      setFormErrors(validationErrors);
    }
  };

  const handleRegValueChange = (e) => {
    const { name, value } = e.target;

    // Update registrationFormData for other fields
    setRegistrationFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Handle phone number input
    if (name === "phone") {
      const numbersOnly = value.replace(/[^\d]/g, "");
      setRegistrationFormData((prev) => ({
        ...prev,
        [name]: numbersOnly,
      }));
    }

    // Validate the changed field
    const validationErrors = validateForm(
      {
        ...registrationFormData,
        [name]: name === "phone" ? value.replace(/[^\d]/g, "") : value,
      },
      [name]
    );

    // Special handling for confirm password
    if (name === "confirmPassword" || name === "password") {
      const passwordValue =
        name === "password" ? value : registrationFormData.password;
      const confirmValue =
        name === "confirmPassword"
          ? value
          : registrationFormData.confirmPassword;

      if (confirmValue && passwordValue !== confirmValue) {
        validationErrors.confirmPassword = "Passwords do not match";
      }
    }

    // setFieldErrors((prev) => ({
    //   ...prev,
    //   [name]: validationErrors[name] || "",
    // }));

    // Mark field as touched
    setTouched((prev) => ({
      ...prev,
      [name]: true,
    }));
  };

  const handleUserDetailsChange = (e) => {
    const { name, value } = e.target;

    // Update user details
    setUserDetails((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Track changes
    setHasChanges(true);

    // Validate field immediately
    const validationErrors = validateForm({ ...userDetails, [name]: value }, [
      name,
    ]);
    setLoginErrors((prev) => ({
      ...prev,
      [name]: validationErrors[name] || "",
    }));
  };

  const handleAppleDetailsChange = (e) => {
    const { name, value } = e.target;

    // Update user details
    setAppleRegisterationDetails((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Track changes
    setHasChanges(true);

    // Validate field immediately
    const validationErrors = validateForm(
      { ...appleRegisterationDetails, [name]: value },
      [name]
    );
    setAppleFieldErrors((prev) => ({
      ...prev,
      [name]: validationErrors[name] || "",
    }));
  };

  const handleLinkAppleUserDeatils = async (e) => {
    e.preventDefault();

    trackButtonClick({
      eventName: "apple_link_details_click",
      eventSource: "Apple user details form submission",
      eventCategory: "Apple Registration",
    });

    // Validate form fields
    const validationErrors = validateForm(appleRegisterationDetails, [
      "firstName",
      "lastName",
      "email",
    ]);

    const formattedPayload = new URLSearchParams();
    formattedPayload.append("email", appleRegisterationDetails?.email);
    await handleIsValidEmail(formattedPayload.toString());

    if (Object.keys(validationErrors).length > 0) {
      setAppleFieldErrors(validationErrors);
      toast.error("Please fill in all required fields.");

      trackButtonClick({
        eventName: "apple_link_details_validation_error",
        eventSource: "Form validation failed",
        eventCategory: "Apple Registration",
      });

      return;
    }
    // Prepare payload
    const payload = {
      firstName: appleRegisterationDetails?.firstName?.trim(),
      lastName: appleRegisterationDetails?.lastName?.trim(),
      emailId: appleRegisterationDetails?.email?.trim(),
      encAlgVersion: "V4",
      token: appleUserInfo?.authorization?.id_token,
      jwtToken: appleUserInfo?.authorization?.id_token,
      code: appleUserInfo?.authorization.code,
      newURI: "Y",
    };

    try {
      const response = await handleSocialAuth(payload, "appleWeb");

      if (response?.status === "SUCCESS") {
        trackApiCall({
          eventName: "apple_link_details_success",
          eventSource: "Apple user linking successful",
          eventCategory: "Apple Registration",
        });

        setIsSocialSignin(true);
        setShowAppleDetailsScreen(false);

        const { status, data } = await getUserProfile();
        dispatch(setProfileInfo(data));
        setIsFromLoginSignupPage(true);

        store.dispatch(setAuthenticated(true));

        if (
          !data?.userDetails?.phoneNumber ||
          data?.userDetails?.phoneNumber?.length === 0
        ) {
          setIsPhoneNumberNotAvailable(true);
        }
        const isPhoneVerified = data?.userDetails?.phoneNumberVerified;
        dispatch(setIsOtpVerificationModalRequired(!isPhoneVerified));

        if (isOtpVerificationModal && !isPhoneVerified) {
          const phoneNumber = data?.userDetails?.phoneNumber;
          dispatch(
            showOtpModal({
              phoneNumber: phoneNumber,
              redirectScreen: "LOGINSIGNUP",
            })
          );
        }

        await postSuccesfulSignIn();

        const profData = await checkLoginStatus();

        dispatch(
          userData({
            userFirstName: profData.userFirstName,
            userType: profData.userType,
            isUserLoggedIn: true,
            user: profData,
          })
        );

        // await getExperiments("IntroHubzu");
        const redisPayload = new FormData();
        redisPayload.append(
          "emailAddr",
          response?.data?.user?.loggedInUserDetail?.userEmailId
        );


        if (show?.location === "Alerts" || show?.location === "Popup") {
          dispatch(
            userData({
              userFirstName: profData?.userFirstName?.trim(),
              userType: "BUYR",
              isUserLoggedIn: true,
              user: {
                ...profData,
                firstName: profData.userFirstName.trim(),
                lastName: profData.userLastName.trim(),
                email: profData?.userEmailId.trim(),
                phone: profData?.primaryPhone,
              },
            })
          );
          dispatch(setAlertsRegister(true));
          setCookie("subscribedUser", false);
          dispatch(setIsUserSubscribed(false));
          deleteCookie("subscribeEmail");
        }
        if (show?.loginModal) {
          dispatch(setLoginModal(false));
          dispatch(setIsAddedToSaved(true));
        }

        setLoginCookie(registrationFormData?.email?.trim());

        localStorage.setItem(
          "user",
          JSON.stringify({
            firstName: data?.userDetails?.firstName?.trim(),
            lastName: data?.userDetails?.lastName?.trim(),
            email: data?.userDetails?.email?.trim(),
            phone: data?.userDetails?.phone,
          })
        );

        toast.success("Registration successful!");
        setIsPhoneNumberVerification(!isPhoneVerified);
      } else {
        trackApiCall({
          eventName: "apple_link_details_failure",
          eventSource: "Apple user linking failed",
          eventCategory: "Apple Registration",
        });
      }
    } catch (error) {
      toast.error(error.message);
      console.error("Error updating user details:", error);
    }
  };

  const handleUpdateUserDetails = async (e) => {
    e.preventDefault();
    setChangePhoneErrorMsg("");
    setOtpErrorMessage("");

    var validationErrors = [];
    if (isSocialSignin) {
      validationErrors = validateForm(userDetails, ["phoneNumber"]);
    } else {
      validationErrors = validateForm(userDetails, [
        "firstName",
        "lastName",
        "email",
        "phoneNumber",
      ]);
    }
    // Validate form fields

    if (Object.keys(validationErrors).length > 0) {
      setLoginErrors(validationErrors);
      toast.error("Please fill in all required fields.");
      return; // Stop submission - prevents URL change
    }

    // Prevent API call if no changes
    // if (!hasChanges) {
    //   toast.warning("No changes detected.");
    //   return;
    // }

    // Prepare payload
    const payload = {
      firstName: userDetails.firstName?.trim(),
      lastName: userDetails.lastName?.trim(),
      phoneNumber: userDetails.phoneNumber?.trim(),
    };

    try {
      setIsUserDetailsUpdating(true);
      const response = await updateUserDetails(payload);

      if (response?.status === "SUCCESS") {
        toast.success("User details updated successfully!");
        const isPhoneVerifiedResponse = await isPhoneNoVerified(
          userDetails.phoneNumber
        );
        const isPhoneVerified = isPhoneVerifiedResponse?.data?.data;
        dispatch(setIsOtpVerificationModalRequired(!isPhoneVerified));
        setIsFromLoginSignupPage(false);

        if (isOtpVerificationModal && !isPhoneVerified) {
          dispatch(
            showOtpModal({
              phoneNumber: userDetails.phoneNumber,
              redirectScreen: "LOGINSIGNUP",
            })
          );
        } else {
          if (isPhoneVerified) {
            navigate("/");
          } else {
            setUserPhoneNumber(userDetails.phoneNumber);
            const payload = {
              phoneNumber: userDetails.phoneNumber,
              verificationType: "sms",
            };
            const response = await sendVerificationCode(payload);

            if (
              response?.status === "FAILURE" &&
              response?.errorCode.startsWith("Invalid")
            ) {
              setOtpErrorMessage(
                "We are facing technical difficulties, please try again later."
              );
            }

            if (response?.errorCode === "PHONE_NUMBER_ALREADY_IN_USE") {
              setChangePhoneErrorMsg(
                "This phone number is already verified for another user. Please use a different number."
              );
            } else {
              setConfirmProfileActive(false);
              setIsPhoneNumberVerification(true);
              setChangePhoneErrorMsg("");
            }
          }
        }
      } else {
        throw new Error(response?.message || "Failed to update user details.");
      }
    } catch (error) {
      toast.error(error.message);
      console.error("Error updating user details:", error);
    } finally {
      setIsUserDetailsUpdating(false);
    }
  };

  const handlePassword = async (password) => {
    const formData = new FormData();
    formData.append("emailId", registrationFormData.email);
    formData.append(
      "passCode",
      await encrypt(password ? password : registrationFormData.password)
    );
    formData.append(
      "retypePassCode",
      await encrypt(registrationFormData.confirmPassword || "")
    );
    formData.append("userType", "NEWUSER");
    formData.append("cryptoAlgVersion", "V3");
    const payload = {
      requestId: generateRandomID(),
    };
    const token = await getRequestId(payload);
    formData.append("requestId", token);

    try {
      setFieldApiValdiationRunning(true);
      const isPasswordValid = await isValidPassword(formData);
      if (isPasswordValid?.status === "SUCCESS") {
        return true;
      } else {
        return false;
      }
    } catch (error) {
      console.error("Error checking password:");
    } finally {
      setFieldApiValdiationRunning(false);
    }
  };

  const onRegistrationInputBlur = async (e) => {
    const { name, value } = e.target;
    // Create a copy of current form data for validation
    const currentFormData = {
      ...registrationFormData,
      [name]: value,
    };

    // Validate the specific field that was blurred
    const validationErrors = validateForm(currentFormData, [name]);

    // Update error state for the specific field
    setFieldErrors((prev) => ({
      ...prev,
      [name]: validationErrors[name] || "",
    }));

    // Mark the field as touched
    setTouched((prev) => ({
      ...prev,
      [name]: true,
    }));

    if (name === "email") {
      const emailValue = registrationFormData?.email;
      const formattedPayload = new URLSearchParams();
      formattedPayload.append("email", emailValue);
      await handleIsValidEmail(formattedPayload.toString());
    } else if (name === "password") {
      const passwordValue = registrationFormData?.password;

      try {
        const isPasswordValid = await handlePassword(passwordValue);

        if (isPasswordValid && registrationFormData.email === "") {
          setFieldErrors((prev) => ({
            ...prev,
            password: "Please enter email address to proceed further",
          }));
        }
      } catch (error) {
        console.error("Error checking password:", error);
      }
    } else if (name === "phone" && value !== "") {
      const phoneNumber = registrationFormData.phone;
      try {
        setFieldApiValdiationRunning(true);
        const isInUse = await checkPhoneNumberInUse(phoneNumber);

        if (isInUse?.status === "SUCCESS" && isInUse?.data) {
          setFieldErrors((prev) => ({
            ...prev,
            phone:
              "This phone number is already verified for another user. Please use a different number.",
          }));
        }
      } catch (error) {
        console.error("Error checking phone number:", error);
      } finally {
        setFieldApiValdiationRunning(false);
      }
    } else if (name === "confirmPassword") {
      const passwordValue = registrationFormData?.password;
      const confirmPasswordValue = registrationFormData?.confirmPassword;
      if (passwordValue !== confirmPasswordValue) {
        setFieldErrors((prev) => ({
          ...prev,
          confirmPassword: "Passwords do not match",
        }));
      }
    }
  };
  const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));
  const syncRecentSearches = async () => {
    var recentSearchLocal = localStorage.getItem("recentSearch");
    recentSearchLocal = recentSearchLocal && JSON.parse(recentSearchLocal);
    if (recentSearchLocal?.cookieElements?.length > 0) {
      const notSyncSearches = recentSearchLocal?.cookieElements.filter(searchItem => searchItem.flag === false);
      await Promise.allSettled(notSyncSearches.reverse().map(async searchItem => {
        if (searchItem.value) {
          await delay(100);
          await saveRecentSearch({searchBy: searchItem.value, url: searchItem.id, searchURI: searchItem.id});
        }
      }));
      const allRecentSearches = await getUserRecentSearch();
      let recentSearch = {
        "id": null,
        "value": "awsRecentSearch",
        "characterLimit": 15,
        "mobileCharacterLimit": 12,
        "showLimit": 5,
        "mobileShowLimit": 3,
        "cookieElements": allRecentSearches.map(recent => ({...recent, defaultSearchText: recent.value}))
      }
      recentSearch = JSON.stringify(recentSearch);
      localStorage.setItem("recentSearch", recentSearch);
      localStorage.setItem("goBackSearch", JSON.stringify(allRecentSearches.length > 0 ? {...allRecentSearches[0], defaultSearchText: allRecentSearches[0].value }: {}));
    } else {
      const allRecentSearches = await getUserRecentSearch();
      let recentSearch = {
        "id": null,
        "value": "awsRecentSearch",
        "characterLimit": 15,
        "mobileCharacterLimit": 12,
        "showLimit": 5,
        "mobileShowLimit": 3,
        "cookieElements": allRecentSearches.map(recent => ({...recent, defaultSearchText: recent.value}))
      }
      recentSearch = JSON.stringify(recentSearch);
      localStorage.setItem("recentSearch", recentSearch);
      localStorage.setItem("goBackSearch", JSON.stringify(allRecentSearches.length > 0 ? {...allRecentSearches[0], defaultSearchText: allRecentSearches[0].value }: {}));
    }
  }

  const postSuccesfulSignIn = async () => {
    const { status, data } = await getUserProfile();
    dispatch(setProfileInfo(data));

    getWebCMS("pages/globalAlerts/firebaseConfig").then((response) => {
      dispatch(setFirebaseConfig(response?.results?.[0]));

      authenticateFirebase((response?.results?.[0]).integnew);
    });
    syncRecentSearches();
  };

  const closeOffcanvas = () => {
    const offcanvasElement = document.getElementById("subscribeUserProfile");
    if (offcanvasElement) {
      const closeButton = offcanvasElement.querySelector(
        '[data-bs-dismiss="offcanvas"]'
      );
      if (closeButton) {
        closeButton.click();
      }
    }
  };

  const handleFormRegistration = async (e) => {
    e.preventDefault();

    trackButtonClick({
      eventName: "submit_registration_click",
      eventSource: "User register button click",
      eventCategory: "Registration",
    });

    setUserDetails({
      firstName: registrationFormData.firstName,
      lastName: registrationFormData.lastName,
      phoneNumber: registrationFormData.phone,
      email: registrationFormData.email,
    });

    // If fieldErrors exists and has any properties, return early
    const hasErrors = Object.values(fieldErrors).some(
      (errorMessage) => errorMessage !== ""
    );
    if (hasErrors) {
      console.log("Found validation errors:", fieldErrors);
      return;
    }

    const passwordValue = registrationFormData?.password;
    const confirmPasswordValue = registrationFormData?.confirmPassword;
    const fieldsToValidate = Object.keys(registrationFormData);

    if (passwordValue !== confirmPasswordValue) {
      setFieldErrors((prev) => ({
        ...prev,
        confirmPassword: "Passwords do not match",
      }));
      return;
    }

    const newErrors = validateForm(registrationFormData, fieldsToValidate);
    setFieldErrors(newErrors);

    if (Object.keys(newErrors).length > 0) return;

    try {
      // setIsLoading(true);
      setRegisterLoading(true)
      setPageLoading(true);
      setRegistrationError("");

      const registrationData = {
        firstName: registrationFormData.firstName?.trim(),
        lastName: registrationFormData.lastName?.trim(),
        emailId: registrationFormData.email?.trim(),
        phoneNumber: registrationFormData.phone,
        password: await encrypt(registrationFormData.password),
        cryptoAlgVersion: "V3",
        requestId: generateRandomID(),
        ...(isSubscribed && { smsOptInFlag: "Y" }),
      };

      const payload = {
        requestId: generateRandomID(),
      };

      const formattedPayload = new URLSearchParams();
      formattedPayload.append("email", registrationFormData?.email);

      await handleIsValidEmail(formattedPayload.toString());

      await getRequestId(payload);

      await handlePassword(registrationFormData?.password);

      await checkPhoneNumberInUse(registrationFormData.phone);

      const registrationResponse = await registerUser(registrationData);

      if (registrationResponse?.status === "SUCCESS") {
        const userId = registrationResponse?.data || "";
        if (userId) {
          dispatch(setProfileInfo({ ...store.getState().user.user, realbidUserId: userId }));
          // Sync the analytics user id to the `gaUserId` cookie so
          // getUserContext() can attach user_uid to all subsequent events.
          setCookie("gaUserId", userId, 30);
        }
        trackApiCall({
          eventName: "register_completed",
          eventSource: "Registration Form Submit",
          eventCategory: getEventCategory(),
          user_uid: userId,
        });

        const loginFormdata = new FormData();
        loginFormdata.append("username", registrationFormData.email);
        loginFormdata.append(
          "password",
          await encrypt(registrationFormData.password)
        );
        loginFormdata.append("requestId", generateRandomID());
        loginFormdata.append("cryptoAlgVersion", "V3");
        loginFormdata.append("encAlgVersion", "V4");

        const redisPayload = new FormData();
        redisPayload.append(
          "emailAddr",
          await encrypt(registrationFormData.email)
        );

        const directSignInResponse = await signIn(loginFormdata);

        const profData = await checkLoginStatus();

        dispatch(
          userData({
            userFirstName: profData.userFirstName,
            userType: profData.userType,
            isUserLoggedIn: true,
            user: profData,
          })
        );

        // await getExperiments("IntroHubzu");

        const { status, data } = await getUserProfile();
        dispatch(setProfileInfo(data));
        dispatch(setShowTabsInModal(true));
        dispatch(setShowContinueBtn(false));

        trackApiCall({
          eventName: "user_sign_in_success",
          eventSource: "Register signin",
          eventCategory: "Sign-In",
          user_uid:
            data?.userDetails?.realbidUserId ||
            data?.realbidUserId ||
            data?.userDetails?.userId ||
            userId,
        });

        await postSuccesfulSignIn();

        // const isPhoneVerified =
        //   directSignInResponse?.data?.user?.loggedInUserDetail
        //     ?.phoneNumberVerified;

        const isPhoneVerifiedResponse = await isPhoneNoVerified(
          registrationFormData.phone
        );

        const isPhoneVerified = data?.userDetails?.phoneNumberVerified;

        isPhoneNoVerified &&
          trackApiCall({
            eventName: "new_mobile_verification",
            eventCategory: "New Register",
          });

        dispatch(setIsOtpVerificationModalRequired(!isPhoneVerified));
        setIsFromLoginSignupPage(true);
        setUserPhoneNumber(registrationFormData.phone);
        if (isOtpVerificationModal && !isPhoneVerified) {
          const phoneNumber = data?.userDetails?.phoneNumber;
          dispatch(
            showOtpModal({
              phoneNumber: phoneNumber,
              redirectScreen: "LOGINSIGNUP",
            })
          );
        }

        if (show?.location === "Alerts" || show?.location === "Popup") {
          dispatch(
            userData({
              userFirstName:  data?.userDetails?.firstName?.trim(),
              userType: "BUYR",
              isUserLoggedIn: true,
              user: {
                ...data?.userDetails,
                firstName: data?.userDetails?.firstName?.trim(),
                lastName: data?.userDetails?.lastName?.trim(),
                email: data?.userDetails?.email?.trim(),
                phone: data?.userDetails?.phone,
              },
            })
          );
          dispatch(setAlertsRegister(true));
          setCookie("subscribedUser", false);
          dispatch(setIsUserSubscribed(false));
          deleteCookie("subscribeEmail");
          setTimeout(() => closeOffcanvas(), 500);
        }
        if (show?.loginModal) {
          dispatch(setLoginModal(false));
          dispatch(setIsAddedToSaved(true));
        }

        setLoginCookie(registrationFormData?.email?.trim());

        if (directSignInResponse?.status === "SUCCESS") {
          localStorage.setItem(
            "user",
            JSON.stringify({
              firstName: registrationFormData.firstName?.trim(),
              lastName: registrationFormData.lastName?.trim(),
              email: registrationFormData.email?.trim(),
              phone: registrationFormData.phone,
            })
          );

          toast.success("Registration successful!");
          setIsPhoneNumberVerification(!isPhoneVerified);
        }
      } else {
        handleRegistrationError(registrationResponse);
      }
    } catch (error) {
      console.error("Registration error:", error);
      handleRegistrationError(error);
    } finally {
      // setIsLoading(false);
      setRegisterLoading(false)
      setPageLoading(false);
    }
  };

  const handlePhoneUpdate = (e) => {
    const { name, value } = e.target;
    if (name === "phone" && !/^[0-9]*$/.test(value)) return;
    setAddedPhoneNumber(value);
    // setFormData({ ...formData, [name]: value });
    setPhoneNumberError("");
  };

  // const handleUpdatePhoneDetails = (event) => {
  //   event.preventDefault();
  //   // Perform the desired action
  //   console.log('Button clicked');
  // };

  const validatePhoneNumber = async () => {
    // Basic validation first
    if (!addedPhoneNumber || addedPhoneNumber.length < 10) {
      setPhoneNumberError("Please enter valid phone number");
      return;
    }

    if (!/^[0-9]{10}$/.test(addedPhoneNumber)) {
      setPhoneNumberError("Phone number must be 10 digits");
      return;
    }

    try {
      const isInUse = await checkPhoneNumberInUse(addedPhoneNumber);
      console.log("isInUse -> ", isInUse);
      if (isInUse?.data === true) {
        setPhoneNumberError("Phone number already in use");
      } else {
        setPhoneNumberError("");
      }
    } catch (error) {
      console.error("Error validating phone number:", error);
      setPhoneNumberError("Error validating phone number. Please try again.");
    }
  };

  const handleUpdatePhoneDetails = async () => {
    if (addedPhoneNumber.length < 10) {
      setPhoneNumberError("Please enter valid phone number");
      return;
    }
    const isInUse = await checkPhoneNumberInUse(addedPhoneNumber);
    if (isInUse?.data === true) {
      setPhoneNumberError("Phone number already in use");
      return;
    } else {
      const payload = {
        firstName: userData?.user?.firstName?.trim(),
        lastName: userData?.user?.lastName?.trim(),
        phoneNumber: addedPhoneNumber,
      };

      try {
        setIsUserDetailsUpdating(true);
        const response = await updateUserDetails(payload);

        if (response?.status === "SUCCESS") {
          const { status, data } = await getUserProfile();
          dispatch(setProfileInfo(data));
          setIsPhoneNumberNotAvailable(false);

          setUserDetails({
            firstName: data?.userDetails?.firstName,
            lastName: data?.userDetails?.lastName,
            phoneNumber: data?.userDetails?.phoneNumber,
            email: data?.userDetails?.emailId,
          });

          await isPhoneNoVerified(addedPhoneNumber);
          // const isPhoneVerified = isPhoneVerifiedResponse?.data?.data;
          const isPhoneVerified =
            response?.data?.user?.loggedInUserDetail?.phoneNumberVerified;

          dispatch(setIsOtpVerificationModalRequired(!isPhoneVerified));
          setIsFromLoginSignupPage(true);

          if (isOtpVerificationModal && !isPhoneVerified) {
            dispatch(
              showOtpModal({
                phoneNumber: addedPhoneNumber,
                redirectScreen: "LOGINSIGNUP",
              })
            );
          } else {
            if (isPhoneVerified) {
              navigate("/");
            } else {
              setUserPhoneNumber(addedPhoneNumber);
              const payload = {
                phoneNumber: addedPhoneNumber,
                verificationType: "sms",
              };
              const response = await sendVerificationCode(payload);

              if (
                response?.status === "FAILURE" &&
                response?.errorCode.startsWith("Invalid")
              ) {
                setOtpErrorMessage(
                  "We are facing technical difficulties, please try again later."
                );
              }

              if (response?.errorCode === "PHONE_NUMBER_ALREADY_IN_USE") {
                setChangePhoneErrorMsg(
                  "This phone number is already verified for another user. Please use a different number."
                );
              } else {
                setConfirmProfileActive(false);
                setIsPhoneNumberVerification(true);
                setChangePhoneErrorMsg("");
              }
            }
          }
        } else {
          throw new Error(
            response?.message || "Failed to update user details."
          );
        }
      } catch (error) {
        toast.error(error.message);
        console.error("Error updating user details:", error);
      } finally {
        setIsUserDetailsUpdating(false);
      }
    }
  };

  // Handle input changes with validation
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setRegistrationFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Validate single field on change
    const fieldErrors = validateForm(
      { ...registrationFormData, [name]: value },
      [name]
    );

    // Special case for confirm password
    if (name === "confirmPassword") {
      if (!value) {
        fieldErrors.confirmPassword = "Please confirm your password";
      } else if (value !== registrationFormData.password) {
        fieldErrors.confirmPassword =
          "Password and confirm password should be same";
      }
    }

    setFieldErrors((prev) => ({
      ...prev,
      [name]: fieldErrors[name] || "",
    }));
  };

  // Component setup with script loading
  useEffect(() => {
    const loadAppleScript = () => {
      return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src =
          "https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js";
        script.async = true;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });
    };

    const initializeAppleSignIn = async () => {
      try {
        await loadAppleScript();
      } catch (error) {
        console.error("Failed to load Apple Sign In script:", error);
      }
    };

    initializeAppleSignIn();
  }, []);

  const handleGoogleLogin = (e) => {
    setUpdateDetails(true);
    e.preventDefault();
    setLoginError("");
    googleLogin();
  };

  const handleAppleClick = (e) => {
    e.preventDefault();
    setLoginError("");
    handleAppleLogin();
    // <AppleSignin />
  };


  useEffect(() => {
    // if (isFromAlerts) {


    setShowHelp(false);
    printWarning(""); { }
    if (show?.location === "Popup") {
      if (show?.loginTab === "loginTab") {
        setIsLogin(true);
        setShoulShowRegister(false);
      } else {
        setIsLogin(false);
        setShoulShowRegister(true);
      }
    }
    // }
  }, [show, isFromAlerts]);

  return (
    <>
      <Container fluid className="split-page p-0">
        {/* <div className="col-lg-12">{pageLoading && <Loader />}</div> */}
        <Row className="g-0">
          <Col
            md={6}
            className={`form-col login-page-width ${isConfirmProfileActive && "phoneVerification"
              } ${isFromAlerts ? "" : "login-page-width-responsive"}`}
            style={{
              margin: "0 auto",
              width: isFromAlerts ? "auto" : "530px",
            }}
          >
            <div>
              <div className="sign_up_form">
                <Row>
                  {isFromAlerts !== "Y" ? (
                    <Col xs={12} md={6} className="pt-5">
                      <a
                        className={`navbar_brand  ${isConfirmProfileActive && "navbar_brand_loginsignup"
                          }`}
                        href="/"
                        onClick={(e) => {
                          if (showPasswordExpired) {
                            e.preventDefault();
                            userSignOut({});
                            dispatch(logOut({ isUserLoggedIn: false }));
                            deleteCookie("isLoggedIn");
                          }
                        }}
                      >
                        <img
                          className="logo2 contain img-fluid hubzu-signup-logo"
                          src={
                            CmsData?.hubzuLogo
                              ? `${"/" + CmsData?.hubzuLogo}`
                              : "/assets/images/hubzu-logo.png"
                          }
                          alt="hubzu-logo.png"
                          width="50%"
                        />
                      </a>
                    </Col>
                  ) : null}
                </Row>
              </div>
              {!show?.loginModal && show?.location !== "Alerts" && <hr />}
              {warningMessage.length > 0 && (
                <div className="alert alert-warning" role="alert">
                  {warningMessage}
                </div>
              )}
              {/* <div> */}
              {isConfirmProfileActive ? (
                <UserProfileForm
                  errors={errors}
                  userDetails={userDetails}
                  onChange={handleUserDetailsChange}
                  onSubmit={handleUpdateUserDetails}
                  isSubmitting={isUserDetailsUpdating}
                  changePhoneErrorMsg={changePhoneErrorMsg}
                  isFreshSocialSignin={isFreshSocialSignin}
                />
              ) : (
                ""
              )}
              {showHelp &&
                isFromAlerts === "Y" &&
                show?.location === "Alerts" && (
                  <Button
                    variant="link"
                    onClick={() => {
                      setShowHelp(false);
                      setIsLogin(true);
                    }}
                    className="p-0 text-decoration-none d-flex align-items-center mb-4"
                  >
                    <FaAngleRight
                      color="#2f86f3"
                      fontSize={18}
                      fontFamily="graphikregular"
                    />
                    <span
                      style={{
                        color: "#2f86f3",
                        fontSize: "13px",
                        fontFamily: "graphikregular",
                      }}
                    >
                      Back
                    </span>
                  </Button>
                )}

              {showHelp &&
                isFromAlerts === "Y" &&
                show?.location === "Alerts" && (
                  <h2 className="alert-register-heading pb-3">
                    Forgot your password?
                  </h2>
                )}
              <div>
                {showHelp && showCutomerCare && (
                  <div className="fs-15 welcome-para">
                    <p className="fs-15 welcome-para">
                      {" "}
                      {CmsData?.resetPasswordText}{" "}
                      <a
                        href={`tel:${CmsData?.customerCareNumber}`}
                        className="customer-care"
                      >
                        {CmsData?.customerCareNumber}
                      </a>
                    </p>
                  </div>
                )}
              </div>
              <div>
                {showAppleDetailsScreen ? (
                  <>
                    <p className="registration-confirmProfile-headers ">
                      Please enter your details
                    </p>
                    <p className="phn-verify-subheader">
                      We will link your Apple ID with the below email address
                    </p>

                    <div className="mt-4">
                      <Form>
                        {/* First Row - First Name & Last Name */}
                        <div className="row mb-2">
                          <div className="col-md-6">
                            <Form.Control
                              id="apple-firstname-input"
                              type="text"
                              placeholder="First Name"
                              name="firstName"
                              value={appleRegisterationDetails.firstName}
                              onChange={handleAppleDetailsChange}
                              isInvalid={!!appleFieldErrors.firstName}
                            />
                            <Form.Control.Feedback type="invalid">
                              {appleFieldErrors.firstName}
                            </Form.Control.Feedback>
                          </div>
                          <div className="col-md-6">
                            <Form.Control
                              id="apple-lastname-input"
                              type="text"
                              placeholder="Last Name"
                              name="lastName"
                              value={appleRegisterationDetails.lastName}
                              onChange={handleAppleDetailsChange}
                              isInvalid={!!appleFieldErrors.lastName}
                            />
                            <Form.Control.Feedback type="invalid">
                              {appleFieldErrors.lastName}
                            </Form.Control.Feedback>
                          </div>
                        </div>

                        {/* Second Row - Email (Disabled Field) */}
                        <div className="row mb-2">
                          <div className="col-12">
                            <Form.Control
                              id="apple-email-input"
                              type="email"
                              placeholder="Email ID"
                              name="email"
                              isInvalid={!!appleFieldErrors.email}
                              value={appleRegisterationDetails.email}
                              onChange={handleAppleDetailsChange}
                            />
                            <Form.Control.Feedback type="invalid">
                              {appleFieldErrors.email}
                            </Form.Control.Feedback>
                          </div>
                        </div>
                        {/* Submit Button */}
                        <div className="row">
                          <div className="col-12 text-center">
                            <Button
                              id="apple-link-btn"
                              type="button"
                              onClick={handleLinkAppleUserDeatils}
                              className="btn w-100 save-continue"
                            >
                              Link
                            </Button>
                          </div>
                        </div>
                      </Form>
                    </div>
                  </>
                ) : (
                  ""
                )}
              </div>
              <div>
                <div
                  className="col mt25 tab-pane fade show active"
                  id="home"
                  role="tabpanel"
                >
                  <div></div>
                  {/* End col */}
                  <div>
                    <div className="login_form">
                      <div className="mt-1">
                        <Row>
                          <Col>
                            {!isConfirmProfileActive &&
                              !showAppleDetailsScreen &&
                              !isPhoneNumberVerification &&
                              !isSocialSignin &&
                              !showHelp &&
                              !showPasswordExpired ? (
                              <>
                                {show?.location !== "Alerts" &&
                                  show?.location !== "Popup" && (
                                    <h3 className="welcome-text">
                                      Welcome to Hubzu!
                                    </h3>
                                  )}
                              </>
                            ) : (
                              ""
                            )}
                          </Col>
                        </Row>
                      </div>
                      {isLogin &&
                        !shouldShowRegister &&
                        !isPhoneNumberVerification &&
                        !showAppleDetailsScreen &&
                        !isConfirmProfileActive &&
                        !showHelp &&
                        !isSocialSignin &&
                        !showPasswordExpired ? (
                        loginError ? (
                          <div
                            className="alert alert-warning w-100 welcome-para"
                            role="alert"
                          >
                            {loginError}
                          </div>
                        ) : (
                          // <div className="error-message text-danger mb-3">
                          // </div>
                          <>
                            {isFromAlerts === "Y" && !show?.loginModal && (
                              <h2 className="alert-register-heading pb-3">
                                Sign In
                              </h2>
                            )}

                            <p className="welcome-para">
                              {popUpMsg && (
                                <span className="popupMsg-bidWizard">
                                  You've been inactive for 15 minutes. As a
                                  security measure you've been automatically
                                  logged out. Please 'Sign In' to continue.
                                </span>
                              )}
                              Sign in to access all your notifications, bids,
                              offers, saved searches, messages and more.
                              {!show?.loginModal && (
                                <>
                                  &nbsp;Don't have an account?&nbsp;
                                  <span
                                    onClick={handleToggle}
                                    style={{ cursor: "pointer" }}
                                  >
                                    <Button
                                      variant="link"
                                      style={{
                                        padding: 0,
                                        border: "none",
                                        fontSize: "14px",
                                        fontWeight: "bold",
                                        textDecoration: "underline",
                                      }}
                                    >
                                      {" "}
                                      Register
                                    </Button>
                                  </span>
                                </>
                              )}
                            </p>
                          </>
                        )
                      ) : (
                        <p>
                          {(!isLogin ||
                            shouldShowRegister) &&
                            !isPhoneNumberVerification &&
                            !showAppleDetailsScreen &&
                            !isConfirmProfileActive &&
                            !showHelp &&
                            !isSocialSignin && (
                              <>
                                {isFromAlerts === "Y" && !show?.loginModal && (
                                  <>
                                    {!userSubscribed ? (
                                      <h2 className="alert-register-heading">
                                        {" "}
                                        Register
                                      </h2>
                                    ) : (
                                      <p className="text-center pb-3">
                                        Complete Your Profile
                                      </p>
                                    )}
                                  </>
                                )}
                                {show?.location === "Alerts" ||
                                  show?.location === "Popup" ? (
                                  <>
                                    {!userSubscribed && (
                                      <p className="welcome-para-alerts">
                                        <b> Register with Hubzu</b> to
                                        "favorite" properties, submit bids 24/7,
                                        and receive instant updates.
                                      </p>
                                    )}
                                  </>
                                ) : (
                                  <p className="welcome-para mb30">
                                    <b>Register for free </b>so you can
                                    "favorite" properties, submit bids and
                                    receive instant updates. Already have an
                                    account?{" "}
                                    <span
                                      onClick={handleToggle}
                                      style={{ cursor: "pointer" }}
                                    >
                                      <Button
                                        variant="link"
                                        style={{
                                          padding: 0,
                                          border: "none",
                                          fontSize: "14px",
                                          fontWeight: "bold",
                                          textDecoration: "underline",
                                        }}
                                      >
                                        {" "}
                                        Sign in{" "}
                                      </Button>
                                    </span>
                                  </p>
                                )}
                              </>
                            )}
                        </p>
                      )}
                      <>
                        {showHelp && (
                          <ForgotPassword
                            printWarning={printWarning}
                            setShowCustomerCare={setShowCustomerCare}
                            email={email}
                          />
                        )}
                      </>
                      {showPasswordExpired ? (
                        <div className="mt-4">
                          <h3 className="welcome-text mb-3">Change Password</h3>
                          <p className="welcome-para mb-4">Your password has expired. Please change your password to continue.</p>
                          <ChangePassword
                            isFromSignIn={true}
                            onPasswordChangeSuccess={() => setShowPasswordExpired(false)}
                          />
                        </div>
                      ) : isLogin &&
                        !shouldShowRegister &&
                        !showAppleDetailsScreen &&
                        !isSocialSignin &&
                        !isPhoneNumberVerification ? (
                        <>
                          <form onSubmit={handleFormLogin} noValidate autoComplete="off">
                            <div className="mb-3 mr-sm-2 position-relative">
                              <input
                                id="login-email-input"
                                type="email"
                                name="email"
                                className={`form-control form-control-style ${loginFieldErrors.email
                                    ? "password-is-invalid"
                                    : ""
                                  }`}
                                // id="email"
                                placeholder="Email Address"
                                value={email}
                                aria-label="Email Address"
                                autoComplete="email"
                                onChange={handleLoginFieldChange}
                                onBlur={validateEmailOnBlur}
                                onKeyDown={(e) => {
                                  if (e.key === "Enter") {
                                    e.preventDefault();
                                    handleFormLogin(e);
                                  }
                                }}
                                required
                              />
                              <div
                                className={`position-absolute top-50 end-0 translate-middle-y me-3 ${loginFieldErrors.email && "pb-4"
                                  } `}
                                style={{
                                  zIndex: 1,
                                  color: `${loginFieldErrors.email ? "#f25d49" : ""
                                    } `,
                                }}
                              >
                                {email && <i className="flaticon-tick"></i>}
                              </div>
                              {loginFieldErrors.email && (
                                <div className="error-text-color">
                                  {loginFieldErrors.email}
                                </div>
                              )}
                            </div>

                            <div className="mb-4 mr-sm-2 position-relative">
                              <input
                                id="login-password-input"
                                type={showPassword ? "text" : "password"}
                                name="password"
                                className={`form-control form-control-style ${loginFieldErrors.password
                                    ? "password-is-invalid"
                                    : ""
                                  }`}
                                // id="password"
                                placeholder="Password"
                                value={password}
                                aria-label="Password"
                                autoComplete="off"
                                onChange={handleLoginFieldChange}
                                onBlur={handleLoginFieldChange}
                                onKeyDown={(e) => {
                                  if (e.key === "Enter") {
                                    e.preventDefault();
                                    handleFormLogin(e);
                                  }
                                }}
                                required
                              />
                              <div
                                className={`position-absolute top-50 end-0 translate-middle-y me-3 ${loginFieldErrors.password && "pb-4"
                                  } `}
                                style={{
                                  zIndex: 1,
                                  color: `${loginFieldErrors.password ? "#f25d49" : ""
                                    } `,
                                }}
                              >
                                <span
                                  id="login-password-toggle"
                                  onClick={() => setShowPassword(!showPassword)}
                                  style={{ cursor: "pointer" }}
                                  role="button"
                                  tabIndex={0}
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter" || e.key === " ") {
                                      setShowPassword(!showPassword);
                                    }
                                  }}
                                >
                                  {showPassword ? (
                                    <i
                                      className="fa fa-eye"
                                      aria-label="Hide password"
                                    ></i>
                                  ) : (
                                    <i
                                      className="fa fa-eye-slash"
                                      aria-label="Show password"
                                    ></i>
                                  )}
                                </span>
                              </div>
                              {loginFieldErrors.password && (
                                <div className="d-block error-text-color">
                                  {loginFieldErrors.password}
                                </div>
                              )}
                              {/* {(captchaError || captchaErrorMessage.length > 0) &&
                                < div className="d-block error-text-color">
                              {captchaErrorMessage}
                            </div>
                              } */}
                            </div>
                            {showCaptcha && (
                              <div className="mb-4">
                                <Captcha
                                  className="mb-30"
                                  setCaptchaError={setCaptchaError}
                                  setIsLoading={setIsLoading}
                                />
                              </div>
                            )}

                            <button
                              id="login-submit-btn"
                              type="submit"
                              disabled={fieldApiValidationRunning || isLoading}
                              className="btn btn-log w-100"
                              onClick={handleFormLogin}
                            >
                              {pageLoading ? (
                                <LoadingText text="Sign in..." />
                              ) : (
                                <LoadedText text="Sign in" />
                              )}
                            </button>
                          </form>
                          {/* End input-group */}

                          {/* <div className="form-group form-check custom-checkbox mb-3">
                             <input
                              className="form-check-input"
                              type="checkbox"
                              value=""
                            />
                            <label
                              className="form-check-label form-check-label"

                            >
                              Remember me
                            </label>
                            </div> */}

                          {!showHelp ? (
                            <>
                              <p style={{ fontSize: "12px" }}>
                                {" "}
                                Don't remember your login details?{" "}
                                <Button
                                  id="login-forgot-password-link"
                                  variant="link"
                                  onClick={handleShowHelp}
                                  style={{
                                    padding: 0,
                                    border: "none",
                                    fontSize: "12px",
                                  }}
                                >
                                  {" "}
                                  Get help signing in.{" "}
                                </Button>{" "}
                              </p>
                            </>
                          ) : null}
                          {/* End submit button */}
                        </>
                      ) : (!isLogin ||
                        shouldShowRegister) &&
                        !isPhoneNumberVerification &&
                        !showAppleDetailsScreen &&
                        !isConfirmProfileActive &&
                        !showHelp &&
                        !isSocialSignin ? (
                        // signUp form
                        <div>
                          {registrationError && (
                            <div
                              className="alert alert-warning w-100 welcome-para"
                              role="alert"
                            >
                              {registrationError}
                            </div>
                          )}
                          <form onSubmit={handleFormRegistration} autoComplete="off">
                            {/* First and Last Name in the same row */}
                            <div className="mb-2 d-flex justify-content-between gap-2">
                              <Col md={6}>
                                <div className="flex-fill input-group">
                                  <input
                                    id="register-firstname-input"
                                    type="text"
                                    className={`form-control`}
                                    // id="firstName"
                                    name="firstName"
                                    placeholder="First Name"
                                    value={registrationFormData.firstName}
                                    autoComplete="given-name"
                                    onChange={handleRegValueChange}
                                    onBlur={onRegistrationInputBlur}
                                    onKeyDown={(e) => {
                                      if (e.key === "Enter") {
                                        e.preventDefault();
                                        handleFormRegistration(e);
                                      }
                                    }}
                                    aria-label="First Name"
                                    required
                                  />
                                  {/* <div className="input-group-prepend">
                                    <div className="input-group-text">
                                      {/* <i
                                        className="flaticon-user"
                                        aria-hidden="true"
                                      ></i>
                                    </div>
                                  </div> */}
                                  {fieldErrors.firstName && (
                                    <div className="invalid-feedback d-block">
                                      {fieldErrors.firstName}
                                    </div>
                                  )}
                                </div>
                              </Col>

                              <Col md={6}>
                                <div
                                  className="flex-fill input-group"
                                  style={{ width: "96%" }}
                                >
                                  <input
                                    id="register-lastname-input"
                                    type="text"
                                    className={`form-control`}
                                    // id="lastName"
                                    name="lastName"
                                    placeholder="Last Name"
                                    value={registrationFormData.lastName}
                                    autoComplete="family-name"
                                    onChange={handleRegValueChange}
                                    onBlur={onRegistrationInputBlur}
                                    onKeyDown={(e) => {
                                      if (e.key === "Enter") {
                                        e.preventDefault();
                                        handleFormRegistration(e);
                                      }
                                    }}
                                    aria-label="Last Name"
                                    required
                                  />
                                  {/* <div className="input-group-prepend">
                                    <div className="input-group-text">
                                     <i
                                        className="flaticon-user"
                                        aria-hidden="true"
                                      ></i>
                                    </div>
                                  </div> */}
                                  {fieldErrors.lastName && (
                                    <div className="invalid-feedback d-block">
                                      {fieldErrors.lastName}
                                    </div>
                                  )}
                                </div>
                              </Col>
                            </div>

                            <Col md={12} className="mb-2">
                              <div className="input-group">
                                <input
                                  id="register-email-input"
                                  type="email"
                                  className={`form-control`}
                                  // id="email"
                                  name="email"
                                  placeholder="Email Address"
                                  value={registrationFormData.email}
                                  autoComplete="email"
                                  onChange={handleRegValueChange}
                                  onBlur={onRegistrationInputBlur}
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                      e.preventDefault();
                                      handleFormRegistration(e);
                                    }
                                  }}
                                  aria-label="Email"
                                // required
                                />
                                {isFromAlerts === "Y" &&
                                  show?.location === "Alerts" && (
                                    <div className="input-group-prepend">
                                      <div className="input-group-text">
                                        <OverlayTrigger
                                          placement="bottom"
                                          overlay={
                                            <Tooltip>
                                              All communications will be sent to
                                              this email address
                                            </Tooltip>
                                          }
                                        >
                                          <i
                                            className="fa fa-info-circle"
                                            aria-hidden="true"
                                            style={{
                                              color: "#ADC4DA",
                                              cursor: "pointer",
                                            }}
                                          />
                                        </OverlayTrigger>
                                      </div>
                                    </div>
                                  )}

                                {fieldErrors.email && (
                                  <div className="invalid-feedback d-block">
                                    {fieldErrors.email}
                                  </div>
                                )}
                              </div>
                            </Col>

                            <Col md={12} className="mb-2">
                              <div className="input-group">
                                <input
                                  id="register-phone-input"
                                  type="tel"
                                  className={`form-control`}
                                  // id="phone"
                                  name="phone"
                                  placeholder="Phone"
                                  value={registrationFormData.phone}
                                  autoComplete="tel"
                                  onChange={handleRegValueChange}
                                  onBlur={onRegistrationInputBlur}
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                      e.preventDefault();
                                      handleFormRegistration(e);
                                    }
                                  }}
                                  aria-label="phone"
                                  required
                                  maxLength={10}
                                />
                                {isFromAlerts === "Y" &&
                                  show?.location === "Alerts" && (
                                    <div className="input-group-prepend">
                                      <div className="input-group-text">
                                        <OverlayTrigger
                                          placement="bottom"
                                          overlay={
                                            <Tooltip>
                                              Password should be 8 or more in
                                              length with at least one number,
                                              special character(! # @ % $ ; ^)
                                              and uppercase letter.
                                            </Tooltip>
                                          }
                                        >
                                          <i
                                            className="fa fa-info-circle"
                                            aria-hidden="true"
                                            style={{
                                              color: "#ADC4DA",
                                              cursor: "pointer",
                                            }}
                                          />
                                        </OverlayTrigger>
                                      </div>
                                    </div>
                                  )}

                                {fieldErrors.phone && (
                                  <div className="invalid-feedback d-block">
                                    {fieldErrors.phone}
                                  </div>
                                )}
                              </div>
                            </Col>

                            <Col md={12} className="mb-2">
                              <div className="input-group">
                                <input
                                  id="register-password-input"
                                  type={
                                    passwordVisibility.password
                                      ? "text"
                                      : "password"
                                  }
                                  className={`form-control`}
                                  // id="password"
                                  name="password"
                                  placeholder="Password"
                                  value={registrationFormData.password}
                                  autoComplete="off"
                                  onChange={handleRegValueChange}
                                  onBlur={onRegistrationInputBlur}
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                      e.preventDefault();
                                      handleFormRegistration(e);
                                    }
                                  }}
                                  aria-label="password"
                                  required
                                />
                                <div className="input-group-prepend">
                                  <div className="input-group-text">
                                    <i
                                      style={{
                                        cursor: "pointer",
                                        color: "#ADC4DA",
                                      }}
                                      className={`fa ${passwordVisibility.password
                                          ? "fa-eye"
                                          : "fa-eye-slash"
                                        }`}
                                      aria-hidden="true"
                                      onClick={() =>
                                        handlePasswordVisibility("password")
                                      }
                                    ></i>
                                  </div>
                                </div>
                                {fieldErrors.password && (
                                  <div className="invalid-feedback d-block">
                                    {fieldErrors.password}
                                  </div>
                                )}
                              </div>
                            </Col>

                            <Col md={12} className="mb-2">
                              <div className="input-group">
                                <input
                                  id="register-confirm-password-input"
                                  type={
                                    passwordVisibility.confirmPassword
                                      ? "text"
                                      : "password"
                                  }
                                  className={`form-control`}
                                  // id="confirmPassword"
                                  name="confirmPassword"
                                  placeholder="Confirm Password"
                                  value={registrationFormData.confirmPassword}
                                  autoComplete="off"
                                  onChange={handleRegValueChange}
                                  onBlur={onRegistrationInputBlur}
                                  aria-label="confirm password"
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                      e.preventDefault();
                                      handleFormRegistration(e);
                                    }
                                  }}
                                  required
                                />
                                <div className="input-group-prepend">
                                  <div className="input-group-text">
                                    <i
                                      style={{
                                        cursor: "pointer",
                                        color: "#ADC4DA",
                                      }}
                                      className={`fa ${passwordVisibility.confirmPassword
                                          ? "fa-eye"
                                          : "fa-eye-slash"
                                        }`}
                                      aria-hidden="true"
                                      onClick={() =>
                                        handlePasswordVisibility(
                                          "confirmPassword"
                                        )
                                      }
                                    ></i>
                                  </div>
                                </div>
                                {fieldErrors.confirmPassword && (
                                  <div className="invalid-feedback d-block">
                                    {fieldErrors.confirmPassword}
                                  </div>
                                )}
                              </div>
                            </Col>

                            <div className="form-check subscribe-check align-items">
                             <label className="form-check-label mt5">
                              <input
                                id="register-sms-subscribe-checkbox"
                                className="form-check-input checkbox-check mb-3"
                                type="checkbox"
                                checked={isSubscribed}
                                onChange={() => {
                                  setIsSubscribed(!isSubscribed);
                                  trackButtonClick({
                                    eventName: "opt_for_sms_toggle",
                                    eventParams: {
                                      opt_status: isSubscribed ? "out" : "in",
                                    },
                                    eventCategory: "about-us",
                                    eventSource:
                                      "Register/SignIn sms subscribe",
                                  });
                                }}
                              />
                                Subscribe for text alerts.
                              </label>

                              {isSubscribed && (
                                <p className="mt-2 subscribe-text">
                                  I agree to be contacted according to these{" "}
                                  <span>
                                    <a
                                      target="_blank"
                                      href="/about/terms"
                                      style={{ color: "#428bca" }}
                                      className="terms-link"
                                    >
                                      Terms & Conditions
                                    </a>
                                  </span>
                                  . This consent includes receiving autodialed
                                  calls and texts from Altisource Online
                                  Auction, Inc. and its affiliates. I understand
                                  that this consent is not a condition to
                                  receiving any services.{" "}
                                </p>
                              )}
                            </div>

                            {/* Submit Button */}
                            <button
                              id="register-submit-btn"
                              type="submit"
                              className="btn btn-log w-100"
                              disabled={registerLoading}
                              onClick={handleFormRegistration}
                            >
                              {registerLoading ? (
                                <>
                                  {show?.showContinueBtn ? (
                                    <>
                                      <LoadingText text="Continue..." />
                                    </>
                                  ) : (
                                    <LoadingText text="Registering..." />
                                  )}
                                </>
                              ) : (
                                <>
                                  {show?.showContinueBtn ? (
                                    <>
                                      <LoadedText text="Continue" />
                                    </>
                                  ) : (
                                    <LoadedText text="Register" />
                                  )}
                                </>
                              )}
                            </button>
                          </form>
                        </div>
                      ) : isFromAlerts !== "Y" &&
                        isPhoneNumberVerification &&
                        !showAppleDetailsScreen &&
                        !isPhoneNumberNotAvailable &&
                        !isConfirmProfileActive ? (
                        <OTPVerification
                          phoneNumber={userDetails.phoneNumber}
                          setIsConfirmProfileActive={handleProfileActiveStatus}
                          isModal={false}
                          setChangePhoneErrorMsg={setChangePhoneErrorMsg}
                          isFromGlobalOtpModal={false}
                          isFromLoginSignupPage={isFromLoginSignupPage}
                          otpErrorMessage={otpErrorMessage}
                          onClose={() => setIsPhoneNumberVerification(false)}
                        />
                      ) : (
                        ""
                      )}
                      {(!isLogin ||
                         shouldShowRegister) &&

                        !isPhoneNumberVerification &&
                        !showAppleDetailsScreen &&
                        !isConfirmProfileActive &&
                        !showHelp &&
                        !isSocialSignin && (
                          <p style={{ fontSize: "12px" }}>
                            By clicking on Register, you accept the Hubzu
                            <a
                              href="/about/terms"
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ marginLeft: "5px", color: "#0d6efd" }}
                            >
                              Terms & Conditions{" "}
                            </a>
                            and
                            <a
                              href={CmsData?.privacyPolicy || "/Privacy-Policy/"}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ marginLeft: "5px", color: "#0d6efd" }}
                            >
                              Privacy Policy
                            </a>
                            .
                            {show?.location !== "Popup" && isFromAlerts && !userSubscribed && (
                              <p className="alerts-signed-in">
                                Already registered?{" "}
                                <span
                                  onClick={handleToggle}
                                  style={{ cursor: "pointer" }}
                                >
                                  <Button
                                    className="sign-in-alert"
                                    variant="link"
                                  >
                                    {" "}
                                    Sign in{" "}
                                  </Button>
                                </span>{" "}
                              </p>
                            )}
                          </p>
                        )}
                      {/* social Logins */}
                      {!isConfirmProfileActive &&
                        !isPhoneNumberVerification &&
                        !showAppleDetailsScreen &&
                        !isSocialSignin &&
                        !showPasswordExpired ? (
                        <div className="row mt25 socialLogins">
                          <div className="col-lg-12">
                            <div className="col-lg-12">
                              <p className="welcome-para">
                                Or, sign in with your Google account:
                              </p>
                              <button
                                id="google-signin-btn"
                                type="button" // Changed from "submit" to "button"
                                className="btn btn-googl w-100"
                                onClick={handleGoogleLogin}
                              >
                                <img
                                  src="/assets/images/googleIcon.png"
                                  alt="Google Icon"
                                  height={20}
                                  width={20}
                                  className="mx-3"
                                />
                                Continue with Google
                              </button>
                              <p className="welcome-para">
                                Or, sign in with your Apple account:
                              </p>
                              <div className="col-lg-12">
                                <button
                                  id="apple-signin-btn"
                                  type="submit"
                                  className="btn btn-fb w-100"
                                  onClick={handleAppleClick}
                                >
                                  <i className="fa fa-apple fs-24"></i> Continue
                                  with Apple
                                </button>
                              </div>
                            </div>

                            <p
                              style={{
                                fontSize: "12px",
                                lineHeight: "16px",
                                textAlign: "center",
                              }}
                            >
                              By clicking on Continue with Google, or Continue
                              with Apple, you accept the Hubzu
                              {!show?.loginModal && <br />}
                              <a
                                href={CmsData?.terms || "/about/terms"}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ marginLeft: "5px", color: "#0d6efd" }}
                              >
                                Terms & Conditions{" "}
                              </a>
                              and
                              <a
                                href={CmsData?.privacyPolicy || "#"}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ marginLeft: "5px", color: "#0d6efd" }}
                              >
                                Privacy Policy
                              </a>
                              .
                            </p>
                          </div>
                        </div>
                      ) : (
                        <>
                          {isSocialSignin && isPhoneNumberNotAvailable ? (
                            <div className="container mt-5">
                              <h3 className="welcome-text">
                                Add your phone number
                              </h3>
                              <div className="form-group">
                                <label
                                  htmlFor="phone"
                                  className="welcome-para"
                                  style={{ paddingBottom: 20 }}
                                >
                                  To bid on hubzu properties you'll need to add
                                  your phone number to your profile
                                </label>

                                <input
                                  id="social-phone-input"
                                  type="numeric"
                                  className={`form-control`}
                                  placeholder="Phone"
                                  name="phone"
                                  value={addedPhoneNumber}
                                  autoComplete="tel"
                                  onChange={handlePhoneUpdate}
                                  aria-label="phone"
                                  onBlur={validatePhoneNumber}
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                      e.preventDefault();
                                      handleUpdatePhoneDetails(e);
                                    }
                                  }}
                                  required
                                  maxLength={10}
                                />
                                {phoneNumberError !== null &&
                                  phoneNumberError?.length > 0 && (
                                    <div className="invalid-feedback d-block">
                                      {phoneNumberError}
                                    </div>
                                  )}
                              </div>

                              <button
                                id="social-phone-save-btn"
                                type="button"
                                className="btn btn-log w-100 mt30"
                                onClick={handleUpdatePhoneDetails}
                                style={{ fontFamily: "graphikregular" }}
                              >
                                {isUserDetailsUpdating ? (
                                  <LoadingText text="Saving..." />
                                ) : (
                                  <LoadedText text="Save & Continue" />
                                )}
                              </button>
                            </div>
                          ) : (
                            ""
                          )}
                        </>
                      )}
                    </div>
                    {/* End .col .login_form */}
                  </div>
                </div>
              </div>
              {/* </div> */}
            </div>
          </Col>
          {isFromAlerts !== "Y" ? (
            <Col
              md={6}
              className="image-col position-relative login-image-section"
            >
              {/* Image: Hidden on mobile devices */}
              <img
                className="img-fluid w-100 h-100 d-none d-md-block"
                src="/assets/images/LoginImage.webp"
                alt="regstr.jpg"
                style={{
                  maxWidth: "100%",
                  height: "auto",
                }}
              />

              {/* Text: Visible on all devices, overlap on larger screens, not on mobile */}
              <div className="login-text-container text-center position-absolute bottom-0 start-50 translate-middle-x mb-2 d-none d-md-block">
                <div className="align-items-center">
                  <p className="mb-0 privacy-terms">
                    <img
                      src={FairHousingIcon}
                      alt="Fair Housing Icon"
                      className="me-1 mb-2"
                    />
                    {CmsData?.copyRightCaption}
                  </p>
                </div>

                <p className="mb-1 privacy-terms">{CmsData?.copyRight}</p>
              </div>

              {/* Text: Visible on mobile screens (not overlapping the image) */}
              <div className="login-text-container text-center d-md-none mt-2">
                <div className="align-items-center">
                  <p className="mb-0 privacy-terms">
                    <img
                      src={FairHousingIcon}
                      alt="Fair Housing Icon"
                      className="me-1 mb-2"
                    />
                    {CmsData?.copyRightCaption}
                  </p>
                </div>

                <p className="mb-1 privacy-terms">{CmsData?.copyRight}</p>
              </div>
            </Col>
          ) : null}
        </Row>
      </Container>
    </>
  );
};

export default LoginSignup;
